export default {
    text: {
        addUser: '新增用户',
        editUser: '编辑用户',
        title: '用户管理',
        userInfo: '用户信息',
        inputTips: '请输入用户名/手机号/姓名查询',
        inputTips2: '请输入手机号',
        inputTips3: '请输入纯字母或字母+数字的组合，长度为6-30位',
        inputTips4: '请输入姓名',
        inputTips5: '请选择（可多选）',
        result: '满足条件的搜索结果：',
        company: '条',
        noViewAuth: '当前组织无下级组织，无法选择数据查看权限',
        forbidden: '禁用账号',
        active: '启用账号',
        confrimMsg1: '是否标记用户：',
        confrimMsg2: '的账号禁用?',
        confrimMsg3: '禁用后',
        confrimMsg4: '角色被置空',
        confrimMsg5: '，账号无法使用',
        confrimMsg6: '的账号启用?',
        confrimMsg7: '启用后',
        confrimMsg8: '重新设置账号角色',
        confrimMsg9: '即正常使用本系统',
    },
    label: {
        phone: '手机号:',
        userName: '用户名:',
        name: '姓名:',
        role: '角色:',
        viewAuth: '数据查看权限:',
        status: '状态:',
        detail: '详情',
    },
    table: {
        index: '序号',
        userName: '用户名',
        phone: '手机号',
        name: '姓名',
        role: '角色',
        createTime: '创建时间',
        status: '账号状态',
        operate: '操作',
    },
    validate: {
        userName: '请输入用户名',
        userNameRule: '纯字母或字母+数字的组合，长度为6-30位',
        name: '请输入姓名',
        phone: '请输入手机号',
        rightPhone: '请输入正确手机号',
        role: '请选择角色',
    },
};
